import React from "react";
import { QUOTES } from "../data";

export default function Quotes() {
  return (
    <section id="reviews">
      <div className="section-head">
        <div className="label">§06 · peer review</div>
        <div className="h">Collaborator feedback</div>
        <div className="meta">{QUOTES.length} entries · verified collaborators</div>
      </div>

      <div className="quotes">
        {QUOTES.map((q) => (
          <div className="quote" key={q.nm}>
            <div className="body">{q.body}</div>
            <div className="who">
              <div className="av">{q.in}</div>
              <div className="meta">
                <div className="nm">{q.nm}</div>
                <div className="ro">{q.ro}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
